import React from 'react';
import './TabPanel.css';

/**
 * TabPanel - A reusable tabbed interface component
 * 
 * @param {Object} props
 * @param {Array} props.tabs - Array of tab objects with {id, label} properties
 * @param {string} props.activeTab - ID of the currently active tab
 * @param {Function} props.onTabChange - Function to call when tab is changed
 * @param {React.ReactNode[]} props.children - React children (content for each tab) - must be an array corresponding to tabs
 */
const TabPanel = ({ tabs, activeTab, onTabChange, children }) => {
  // If children is a single element, wrap it in an array
  const childrenArray = React.Children.toArray(children);
  
  return (
    <div className="tab-panel">
      <div className="tab-header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            aria-selected={activeTab === tab.id}
            role="tab"
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab-content" role="tabpanel">
        {React.Children.map(children, (child, index) => {
          // If tabs[index] exists and its id matches activeTab, render the child
          if (tabs[index] && tabs[index].id === activeTab) {
            return child;
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default TabPanel; 